import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <a name="module-storage-modes" id="module-storage-modes"></a>
    <h1 {...{
      "id": "requireuxpstoragemodes"
    }}>{`require('uxp').storage.modes`}</h1>
    <a name="new-module-storage-modes-new" id="new-module-storage-modes-new"></a>
    <h2 {...{
      "id": "modes"
    }}>{`modes()`}</h2>
    <p>{`This namespace describes the file open modes. for eg: open file in read-only or both read-write`}</p>
    <a name="module-storage-modes-readonly" id="module-storage-modes-readonly"></a>
    <h2 {...{
      "id": "readonly--symbol"
    }}>{`readOnly : `}<inlineCode parentName="h2">{`Symbol`}</inlineCode></h2>
    <p>{`The file is read-only; attempts to write will fail.`}</p>
    <a name="module-storage-modes-readwrite" id="module-storage-modes-readwrite"></a>
    <h2 {...{
      "id": "readwrite--symbol"
    }}>{`readWrite : `}<inlineCode parentName="h2">{`Symbol`}</inlineCode></h2>
    <p>{`The file is read-write.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      